import { Encryption } from "../config/common";
import AxiosClientApi from "./axios.services";

/*==================================================== 
    Auth Routers                                                                              
====================================================== */

export function Register(request) {
    return AxiosClientApi.post('/website/auth/register', Encryption(request, true))   
}

export function SendOtp(request) {
    return AxiosClientApi.post('/website/auth/send-user-otp ', Encryption(request, true))  
}

export function verifyOtp(request) {
    return AxiosClientApi.post('/website/auth/verify-otp  ', Encryption(request, true))   
}

export function login(request) {
    return AxiosClientApi.post('/website/auth/login  ', Encryption(request, true))   
}

export function logout(request) {
    
    return AxiosClientApi.post('/website/auth/logout', Encryption(request, true))   
}


export function DeleteAccount(request) {
    
    return AxiosClientApi.post('/website/auth/delete_account', Encryption(request, true))   
}

export function ChangePaawsord(request) {
    
    return AxiosClientApi.post('/website/auth/change-password', Encryption(request, true))   
}


export function ResetPaawsord(request) {
    return AxiosClientApi.post('/website/auth/reset-password', Encryption(request, true))   
}

export function EditProfileSendOtpApi(request) {
    
    return AxiosClientApi.post('/website/auth/otp_send-myprofile', Encryption(request, true))   
}

export function EditProfileApi(request) {
    
    return AxiosClientApi.post('/website/auth/edit-myprofile', Encryption(request, true))   
}


export function CompleteProfileApi(request) {
    return AxiosClientApi.post('/website/auth/complete_profile', Encryption(request, true))   
}


export function getStateList(request) {
    
    return AxiosClientApi.post('admin/auth/state_list', Encryption(request, true))   
}

export function priceSettingList(request) {
    
    return AxiosClientApi.post('admin/auth/price_setting_list', Encryption(request, true))   
}


// getUserProfile
export function GetUserProfile(request) {
    
    return AxiosClientApi.post('/website/auth/getUserProfile', Encryption(request, true))   
}

export function ForgetPasswordOtp(request) {
    
    return AxiosClientApi.post('/website/auth/forgot-password', Encryption(request, true))   
}

export function Conatctus(request) {
    
    return AxiosClientApi.post('/website/cms/add-contact-us', Encryption(request, true))   
}

// getUserProfileSubscribed

export function getUserProfileSubscribed(request) {
    
    return AxiosClientApi.post('/website/auth/getUserProfileSubscribed', Encryption(request, true))   
}


export function GenerateBom(request) {
    
    return AxiosClientApi.post('/website/auth/generate_bom', Encryption(request, true))   
}

export function GenerateBomReplacement(request) {
    return AxiosClientApi.post('/website/auth/generate_bom_replacement', Encryption(request, true))   
}


export function BomList(request) {
    
    return AxiosClientApi.post('/website/auth/getBom_details_list', Encryption(request, true))   
}

export function BomListById(request) {
    
    return AxiosClientApi.post('/website/auth/getBom_details_list_id', Encryption(request, true))   
}
export function BomListByIdReplacement(request) {
    
    return AxiosClientApi.post('/website/auth/getBom_details_by_id', Encryption(request, true))   
}

export function downloadBomDetails(request) {
    
    return AxiosClientApi.post('/website/auth/download_replacement_pdf', Encryption(request, true))   
}

export function downloadRepairPdf(request) {
    return AxiosClientApi.post('/website/auth/download_pdf', Encryption(request, true))   
}

// export_bom_deatils
export function ExportBomDetails(request) {
    
    return AxiosClientApi.post('/website/auth/export_bom_deatils', Encryption(request, true))   
}


// get-faq_without_enc_denc

export function getFaqWithoutcredentails(request) {
    return AxiosClientApi.post('admin/cms/get-faq', Encryption(request, true))   
}



export function getFaqWitcredentails(request) {
    
    return AxiosClientApi.post('website/cms/get-faq', Encryption(request, true))   
}


// admin/cms/without_enc_app_content

export function getAppConetntWithoutcredentails(request) {
    return AxiosClientApi.post('admin/cms/app_content', Encryption(request, true))   
}


export function bannerlistdetails(request) {
    return AxiosClientApi.post('admin/auth/get_banner_list', Encryption(request, true))   
}


// subscription 

export function subscriptionlistdetails(request) {
    
    return AxiosClientApi.post('admin/subscription/subscription_list', Encryption(request, true))   
}

export function UserStripeSubscription(request) {
    
    return AxiosClientApi.post('/website/stripe/stripe_subscription', Encryption(request, true))   
}

// user_subscription_details

export function UserStripeSubscriptiondetails(request) {
    
    return AxiosClientApi.post('/website/stripe/user_subscription_details', Encryption(request, true))   
}

// /website/auth/view_subscription_home_owner

export function homeOwnersubscriptionlist(request) {
    
    return AxiosClientApi.post('/website/auth/view_subscription_home_owner', Encryption(request, true))   
}

export function CancelSubscription(request) {
    
    return AxiosClientApi.post('/website/stripe/cancel_subscription', Encryption(request, true))   
}


//---------------------------------------------------------- Notification ----------------------------

export function UserNotificationList(request) {
    
    return AxiosClientApi.post('/website/auth/notification_list_by_id', Encryption(request, true))   
}





//---------------------------------------------------------- Notification ----------------------------
